<template>
	<div class="tpl activity-list-wrap">
		<mt-header title="我报名的" fixed>
		  <router-link :to="{name:'activity-list'}" slot="left">
		    <mt-button icon="back"></mt-button>
		  </router-link>
		  <mt-button icon="more" slot="right"></mt-button>
		</mt-header>
		<div class="activity-list">
			<mt-loadmore :top-method="refreshActivityList" :bottom-method="loadMoreActivityList" :auto-fill="false" ref="loadmore">
				<list-item :itemInfo="item" v-for="(item,index) in listInfo" :key="index"></list-item>
			</mt-loadmore>
			
		</div>
	</div>
</template>

<script>
	
	import ListItem from "./MyActivityListItem"
	
	export default{
		name:"my-activity-list",
		components:{
			ListItem
		},
		data(){
			return{
				uid:"",
				nowPage:1,
				listInfo:"",
			}
		},
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed","finds");		//属于finds模块
			this.$store.commit("changeTabBarShow",false);	//不显示navbar
			
			this.getListInfo();
		},
		methods:{
			getListInfo(){
				this.$axios({
					url:"Appointment/MyEnrollActivityList",
					method:"post",
					data:{
						uid:this.uid,
						page:this.nowPage,
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						if(this.nowPage==1){
							this.listInfo = res.data.data;
						}else{
							if(res.data.data.length<1){
								this.$toast({
									message:"没有更多内容了~",
									position:"bottom",
									duration:3000
								})
								this.nowPage--;
							}else{
								this.listInfo = this.listInfo.concat(res.data.data);
							}
						}
					}else{
						this.$toast({
							message:"没有更多内容了~",
							position:"bottom",
							duration:3000
						})
						this.nowPage--;
					}
				}).catch(err=>{
					console.log(err);
					this.$indicator.close();
					this.$toast({
						message:"加载超时，请重试",
						position:"bottom",
						duration:3000
					})
				})
			},
			refreshActivityList(){
				this.nowPage = 1;
				this.getListInfo();
				this.$refs.loadmore.onTopLoaded();
				
			},
			loadMoreActivityList(){
				this.nowPage ++;
				this.getListInfo();
				this.$refs.loadmore.onBottomLoaded();
			}
		}
	}
</script>

<style scoped>
	.activity-list-wrap{
		padding-top: 2.5rem;
	}
	.activity-list{
		overflow-y: scroll;
	}
</style>


// WEBPACK FOOTER //
// src/components/Finds/MyActivityList.vue